
(() => {
  'use strict';

  // 1. Control de cantidad
  document.querySelectorAll('.qty-control').forEach(group => {
    const input = group.querySelector('input[type="number"]');

    if (!input) return;

    group.querySelector('.qty-minus')?.addEventListener('click', () => {
      input.value = String(
        Math.max(1, (parseInt(input.value, 10) || 1) - 1)
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });

    group.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = String(
        (parseInt(input.value, 10) || 1) + 1
      );

      input.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    });
  });

  // 2. Página de producto
  document.querySelectorAll('[data-product-root]').forEach(root => {

    // Galería de imágenes
    const mainImage = root.querySelector(
      '.product-gallery__main-img'
    );

    root.querySelectorAll('[data-gallery-image]').forEach(button => {
      button.addEventListener('click', () => {

        if (mainImage) {
          mainImage.src = button.dataset.galleryImage;
          mainImage.srcset = '';
          mainImage.alt = button.dataset.galleryAlt || '';
        }

        root.querySelectorAll('.product-gallery__thumb').forEach(item => {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');
      });
    });

    // Elementos del formulario
    const variantSelect = root.querySelector(
      '[data-variant-select]'
    );

    const variantsElement = root.querySelector(
      '[data-product-variants]'
    );

    const price = root.querySelector(
      '[data-product-price]'
    );

    const compare = root.querySelector(
      '[data-compare-price]'
    );

    const inventory = root.querySelector(
      '[data-product-inventory]'
    );

    const submit = root.querySelector(
      '[data-add-to-cart]'
    );

    const buyNowContainer = root.querySelector(
      '[data-buy-now-container]'
    );

    const sku = root.querySelector(
      '[data-product-sku]'
    );

    if (!variantsElement) return;

    let variants = [];

    try {
      variants = JSON.parse(
        variantsElement.textContent
      );
    } catch (error) {
      return;
    }

    const locale = (
      document.documentElement.lang || 'es'
    ).startsWith('es') ? 'es-ES' : 'en-GB';

    const moneyFormatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    });

    const formatMoney = cents => {
      return moneyFormatter.format(cents / 100);
    };

    function updateVariant() {

      const selectedId = variantSelect
        ? variantSelect.value
        : root.querySelector(
            '.product-form input[name="id"]'
          )?.value;

      const variant = variants.find(item => {
        return String(item.id) === String(selectedId);
      });

      if (!variant) return;

      // Precio
      if (price) {
        price.textContent = formatMoney(variant.price);
      }

      // Precio anterior
      if (compare) {
        const discounted =
          variant.compare_at_price &&
          variant.compare_at_price > variant.price;

        compare.hidden = !discounted;

        compare.textContent = discounted
          ? formatMoney(variant.compare_at_price)
          : '';
      }

      // Disponibilidad
      if (inventory) {
        if (variant.available) {

          const tracked =
            variant.inventory_management &&
            variant.inventory_policy === 'deny' &&
            variant.inventory_quantity > 0;

          inventory.innerHTML =
            '<span class="status-dot"></span>' +
            (
              tracked
                ? 'En stock · ' +
                  variant.inventory_quantity +
                  ' unidades disponibles'
                : 'Disponible para comprar'
            );

        } else {

          inventory.innerHTML =
            '<span class="status-dot status-dot--off"></span>' +
            'Agotado';

        }
      }

      // Botón añadir al carrito
      if (submit) {
        submit.disabled = !variant.available;

        const buttonText = variant.available
          ? 'Añadir al carrito '
          : 'Agotado ';

        const firstTextNode = Array.from(
          submit.childNodes
        ).find(node => node.nodeType === Node.TEXT_NODE);

        if (firstTextNode) {
          firstTextNode.textContent = buttonText;
        }
      }

      // Botón comprar ahora
      if (buyNowContainer) {
        buyNowContainer.hidden = !variant.available;
      }

      // Referencia SKU
      if (sku && variant.sku) {
        sku.textContent = variant.sku;
      }

      // Actualizar URL con la variante seleccionada
      if (variantSelect) {
        const url = new URL(window.location.href);

        url.searchParams.set(
          'variant',
          variant.id
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener(
        'change',
        updateVariant
      );
    }

    updateVariant();

  });

})();
